module.exports = __webpack_public_path__ + "img/line_paytable.4011e93a.png";